import React from 'react';
import { Apple, Play } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-white to-amber-50 py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-5xl lg:text-6xl font-light text-gray-800 leading-tight">
              Simple, powerful appointment scheduling software
            </h1>
            <p className="text-xl text-gray-600">
              The easiest way to schedule customers<br />
              and send appointment reminders
            </p>
            
            <div className="pt-4">
              <button className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-8 py-4 rounded-md transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                Try it for Free
              </button>
            </div>
            
            <div className="flex items-center space-x-6 pt-6">
              <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200">
                <Apple className="w-5 h-5" />
                <span>Download on App Store</span>
              </button>
              <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200">
                <Play className="w-5 h-5" />
                <span>Get it on Google Play</span>
              </button>
            </div>
          </div>
          
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://images.unsplash.com/photo-1632152943364-728220ee6b4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwY2FsZW5kYXIlMjBpbnRlcmZhY2V8ZW58MHx8fHwxNzYxNTA0ODgwfDA&ixlib=rb-4.1.0&q=85" 
                alt="yiBooking Mobile App" 
                className="w-80 h-auto rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 right-0 w-64 h-64 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=300&h=300&fit=crop" 
          alt="Decorative" 
          className="w-full h-full object-cover"
        />
      </div>
    </section>
  );
};

export default Hero;